module.exports = __webpack_public_path__ + "assets/img/fb48-iq.svg";